export default __webpack_public_path__ + "static/media/404.e7e8e8ad.png";